import { createAsyncAction, createAction } from 'typesafe-actions';

export const getContract = createAsyncAction(
  '@GET_CONTRACTS/REQUEST',
  '@GET_CONTRACTS/SUCCESS',
  '@GET_CONTRACTS/FAILURE'
)<DebtContract, Array<GQL.IDebt>, string>();

export const getUpdateDebts = createAsyncAction(
  '@GET_DEBT_CONTRACT/REQUEST',
  '@GET_DEBT_CONTRACT/SUCCESS',
  '@GET_DEBT_CONTRACT/FAILURE'
)<undefined, string, string>();

export const claimPayment = createAsyncAction(
  '@CLAIM_PAYMENT/REQUEST',
  '@CLAIM_PAYMENT/SUCCESS',
  '@CLAIM_PAYMENT/FAILURE'
)<GQL.IClaimPaymentInput & { databaseId: number }, string, string>();

export const setContractInformations = createAction(
  'SET_CONTRACTS_INFORMATIONS'
)<ContractInformations | null>();

export const setSelectedInstallments = createAction(
  'SET_SELECTED_INSTALLMENTS'
)<string[]>();

export const setSelectedPaymentMethod = createAction(
  'SET_SELECTED_PAYMENT_METHOD'
)<number | null>();
